import Jsona, { SwitchCaseJsonMapper } from 'jsona'
import { irwin } from 'config'
import { httpClient } from './httpClient'
import { cancellableQuery } from './utils'
import { snakeCase } from 'change-case-object'

const deserializerAndCase = new Jsona({
  jsonPropertiesMapper: new SwitchCaseJsonMapper({ switchChar: '_' }),
})

function client() {
  return httpClient(irwin.baseUrl)
}

async function searchItineraries(params) {
  return cancellableQuery(searchItinerariesQuery, snakeCase(params))
}

const searchItinerariesQuery = async (params, signal) => {
  const response = await client().get('/v2/itineraries/admin_search', {
    params,
    signal,
  })

  return { data: deserializerAndCase.deserialize(response) }
}

const getItinerary = async id => {
  const response = await client().get(`/v2/itineraries/${id}/admin_show`)
  return {
    data: deserializerAndCase.deserialize(response),
  }
}

export { searchItineraries, getItinerary }
